import api from 'api'
import { WageRule } from './getRule'

type GetRulesRequest = {
  jurisdictionId?: number
}

export const getRules = async (
  request: GetRulesRequest = {}
): Promise<WageRule[]> => {
  const response = await api.get<WageRule[]>('/admin/wage/rules', {
    params: {
      jurisdiction_id: request.jurisdictionId,
    },
  })
  return response.data
}
